import React from 'react';
import PropTypes from 'prop-types';
import { connectToStores } from 'fluxible-addons-react';
import DrawerToggleButton from '../drawer-toggle-button';
import SelectedWinnersStore from '../../stores/selected-winners-store';
import { addWinner, removeWinner } from '../../actions/select-winner';

const ConnectedSelectWinnerButton = connectToStores(
    DrawerToggleButton,
    [SelectedWinnersStore],
    (context, { entry, tooltip }) => {
        const store = context.getStore(SelectedWinnersStore);
        return {
            isSelected: store.isWinner(entry.designId),
            isDisabled: !store.isWinner(entry.designId) && store.hasSelectedMaxWinners(),
            isPrimary: true,
            tooltip,
            onAdd: () => {
                context.executeAction(addWinner, entry);
            },
            onRemove: () => {
                context.executeAction(removeWinner, entry.designId);
            },
        };
    }
);

ConnectedSelectWinnerButton.propTypes = {
    entry: PropTypes.shape({
        designId: PropTypes.number.isRequired,
        imageUrl: PropTypes.string.isRequired,
    }).isRequired,
    tooltip: PropTypes.string.isRequired,
};

ConnectedSelectWinnerButton.contextTypes = {
    getStore: PropTypes.func,
    executeAction: PropTypes.func,
};

const ShowButton = connectToStores(
    ({ showButton, ...props }) => {
        return showButton ? <ConnectedSelectWinnerButton {...props} /> : null;
    },
    [SelectedWinnersStore],
    context => {
        const store = context.getStore(SelectedWinnersStore);
        return {
            showButton: store.getShowDrawer(),
        };
    }
);

export default ShowButton;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/connected/connected-select-winner-button.jsx